<template>
    <div class="edit_point"  v-if="addOk">
        <el-card class="edit_point_account">
           <div slot="header" class="clearfix" style="text-align:center;">
                <span>设备编号</span><span style="color:red">{{myCode}}</span>
            </div>
            <div class="editContent">
                <p>
                    <span class="e_left">OpenId：</span>
                    <el-input v-model="myOpenId"></el-input>
                </p>
                <p>
                    <span class="e_left">Secret：</span>
                    <el-input v-model="mySecret"></el-input>
                </p>
                <p>
                    <span class="e_left">chainstoreGuid：</span>
                    <el-input v-model="myChainstoreGuid"></el-input>
                </p>
                <p>
                    <span class="e_left">consumeNoteItems：</span>
                    <el-input v-model="myConsumeNoteItems"></el-input>
                </p>
            </div>
            <span @click="boxClose" style="position: absolute; top: 0;right:0;padding:10px;color:#FF4949"><i class="el-icon-close Danger"></i></span>
            <el-button type="success" @click="commitEditP" style="width:300px;margin-top:20px;">提交</el-button>
        </el-card>
    </div>
</template>
<script>
    import $axios from '../../https/config'

    export default {
      props: ['addShow', 'editDvceCode'],
      data () {
        return {
          price: 0,
          point: 0,
          deviceCode: '',
          status: '',
          myOpenId:'',
          mySecret:'',
          myChainstoreGuid:'',
          myConsumeNoteItems:''
        }
      },
      computed: {
        addOk: function () {
          return this.addShow
        },
        myCode: {
          get: function () {
            this.deviceCode = this.editDvceCode
            console.log("this.deviceCode1="+this.deviceCode)
            this.getInitParam()
            return this.editDvceCode
          },
          set: function (val) {
            this.deviceCode = val
            console.log("this.deviceCode2="+this.deviceCode)
            this.getInitParam()
          }
        },

      },
      created: function () {
        //this.myOpenId = this.deviceCode +"o";
        //this.mySecret = this.deviceCode +"s";
        //this.myChainstoreGuid = this.deviceCode +"c";
        //this.deviceCode = this.editDvceCode
        //this.getInitParam();
      },
      methods: {
        boxClose () {
          this.$emit('closeEditPointParam', false)
        },
        getInitParam () {
          var that = this
          var params = {
            deviceCode: that.editDvceCode
          }
          $axios.get('/lanhai/getParam', params, 'headers', function (res) {

            if (res && res.resultStatus === true) {
              if (res.resultData!=null){
                that.myOpenId = res.resultData.openid
                that.mySecret = res.resultData.secret
                that.myChainstoreGuid = res.resultData.chainstoreGuid
                that.myConsumeNoteItems = res.resultData.consumeNoteItems
              }else{
                that.myOpenId = ""
                that.mySecret = ""
                that.myChainstoreGuid = ""
                that.myConsumeNoteItems = ""
              }

            }
          },function(){

          })
        },
        commitEditP () {
          var _this = this
          var params = {
            deviceCode: _this.deviceCode,
            openid: _this.myOpenId,
            secret: _this.mySecret,
            chainstoreGuid: _this.myChainstoreGuid,
            consumeNoteItems: _this.myConsumeNoteItems,

          }
          $axios.get('/lanhai/updateParam', params, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              _this.$message({
                type: 'success',
                duration: 1000 * 1,
                message: '修改支付流程成功!'
              })
              _this.boxClose()
            } else {
              _this.$message({
                type: 'error',
                duration: 1000 * 1,
                message: '修改支付流程失败!' + res.errorMessage
              })
            }
          })
        }
      }
    }
</script>
<style lang="scss">
  .edit_point {
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      position: fixed;
      background: rgba(#000, 0.3);
      z-index: 100;
      text-align: center;

      .edit_point_account {
        min-height: 330px;
        width: 700px;
        top: 10%;
        left: 50%;
        z-index: 101;
        margin-left: -350px;
        position: fixed;

        .editContent {
          text-align: left;
          margin-left: 30px;

          .el-input{
            width: 300px;
          }
          .e_left {
              width: 20%;
              display: inline-block;
          }
        }
      }
  }
</style>



// WEBPACK FOOTER //
// src/page/deviceMgr/editParam.vue